/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Shaddow = styled.div`
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 9;
  width: 100%;
  height: 100vh;
`;

export const Container = styled.div`
  position: fixed;
  z-index: 10;
  right: 0;
  width: 60%;
  height: 100vh;
  background: #fff;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;

  padding: 20px;
  font-size: 16px;

  h2 {
    margin-top: 2vh;
  }

  button.icon {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #36ded6;
    background: #36ded6;

    position: absolute;
    right: 2vw;
    top: 2vh;
  }

  div.feedback {
    height: 10vh;
    background: #ccc;
    border: 1px solid #f00;
    border-radius: 5px;
    padding: 1vh;
    margin-top: 1vh;
  }

  div.line {
    height: 0.5px;
    border: 0.5px solid #ccc;
    margin-top: 2vh;
  }

  button.link {
    color: #36ded6;
    font-size: 16px;
    text-decoration: underline;
    border-color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    font-weight: bold;
    margin-top: 2vh;
    margin-bottom: 1vh;
  }

  a {
    color: #36ded6;
    font-size: 16px;
    text-decoration: underline;
    font-weight: bold;
  }

  button.submit {
    padding: 5px;
    border: none;
    background-color: #f7df1e;
    height: 50px;
    width: 219px;
    margin-top: 1vh;
    font-weight: bold;

    position: absolute;
    right: 3vw;
    bottom: 2vh;
  }

  textarea {
    width: 56vw;
    height: 45vh;
    resize: none;
    resize: none;
    background-color: #222;
    border: 1px solid #222;
    padding-top: 30px;
    padding-left: 30px;
    font-size: 20px;
    color: #fff;
  }
`;

export const ImageModal = styled.div`
  position: absolute;
  width: 58vw;
  height: 96vh;
  background-color: #fff;
  border-top-left-radius: 20px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  z-index: 15;

  button {
    cursor: pointer;
    align-self: flex-start;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    margin-bottom: 30px;
  }

  img {
    align-self: center;
    max-width: 25vw;
    max-height: 60vh;
  }
`;
